import type { ProductContext } from "../types";
import { findProductMicrodata } from "./microdata";
import type { PlatformAdapter } from "./types";

declare global {
  interface Window {
    StateManager?: unknown;
    basketData?: unknown;
  }
}

// Shopware 5 (tema Responsive) expõe esses dois globais em toda página da loja. O
// Shopware 6 não usa nenhum dos dois, então a detecção automática não se confunde com ele.
// Quem já passa data-platform="shopware" no snippet nem depende dessa detecção.
export const shopwareAdapter: PlatformAdapter = {
  isCurrentPlatform() {
    return typeof window.StateManager !== "undefined" && typeof window.basketData !== "undefined";
  },

  // body.is--ctl-detail é a classe do controller de PDP. Exigimos ela junto do microdata
  // para não tratar outra página que tenha um Product como se fosse a PDP. Na Melhor
  // Indústria os cards da listagem não trazem microdata, mas o check fica por ser barato.
  isProductPage() {
    return document.body.classList.contains("is--ctl-detail") && findProductMicrodata() !== null;
  },

  getProductContext(): ProductContext {
    return (
      findProductMicrodata() ?? {
        productId: null,
        sku: null,
        gtin: null,
        slug: null,
        slugPath: null,
      }
    );
  },
};
